<template>
  <div class="pb-2">
    <h4 class="text-black font-weight-bold my-4">Chi vuoi consultare?</h4>
    <b-overlay :show="loading" rounded="sm">
      <div class="col-sm-12 col-lg-7 mx-auto">
        <b-form-select
          id="ruolo"
          class="my-2"
          v-model="professionista.tipo"
          :options="ruoli"
          @change="fetchData"
        ></b-form-select>
      </div>

      <div class="col-sm-12 col-lg-7 mx-auto my-4" v-if="professionista.tipo">
        <h4 class="text-capitalize text-secondary">
          Seleziona {{ professionista.tipo }}:
        </h4>
        <!-- <b-form-select v-model="professionista.rif" class="my-4" @input="setName">
          <b-form-select-option
            v-for="(element,ind) in lista"
            :key="ind"
            :value="element.hashid"
          >{{element.fullname}}</b-form-select-option>
        </b-form-select>-->
        <b-form-group
          label="Scegli tra i tuoi contatti frequenti:"
          v-if="contatti"
          class="text-secondary text-left pt-2"
        >
          <b-form-radio-group
            class="m-auto"
            v-model="selected"
            name="frequenti"
            @change="setName"
          >
            <b-form-radio
              v-for="(contatto, ind) in contatti"
              :key="ind"
              :value="contatto.anagrafica"
              :class="contatto.role != professionista.tipo && 'hide__opt'"
              class="text-secondary font-weight-normal text-left"
              >{{ contatto.anagrafica.fullname }}</b-form-radio
            >
            <!-- <b-form-radio-group
            class="col-3 m-auto"
            v-for="(contatto, ind) in contatti"
            :key="ind"
            v-model="selected"
            :name="contatto.anagrafica.fullname"
            plain
            @change="setName"
          >
            <b-form-radio
              v-if="contatto.role == professionista.tipo"
              :value="contatto.anagrafica"
            >{{contatto.anagrafica.fullname}}</b-form-radio>-->
          </b-form-radio-group>
          <!-- <b-form-radio
            v-for="(contatto, ind) in contatti"
            :key="ind"
            v-model="selected"
            name="some-radios"
            :value="contatto.anagrafica"
            @change="setName"
          >{{contatto.role == professionista.tipo && contatto.anagrafica.fullname}}</b-form-radio>-->
        </b-form-group>
        <!-- <div v-if="professionista.rif == null"> -->
        <p class="font-weight-bold text-secondary text-left">
          Cerca per luogo:
        </p>
        <div>
          <p class="pt-1 mb-0 text-secondary text-left">Regione:</p>
          <b-form-select
            v-model="regione"
            class="mt-2 mb-4"
            @change="handleRegioni"
          >
            <b-form-select-option
              v-for="(element, ind) in regioni"
              :key="ind"
              :value="element"
              >{{ element }}</b-form-select-option
            >
          </b-form-select>
        </div>
        <div v-if="regione">
          <p class="pt-1 mb-0 text-secondary text-left">Provincia:</p>
          <b-form-select
            v-model="provincia"
            class="mt-2 mb-4"
            @change="handleProvince"
          >
            <b-form-select-option :value="null"
              >Scegli provincia</b-form-select-option
            >
            <b-form-select-option
              v-for="(element, ind) in province"
              :key="ind"
              :value="element"
              >{{ element }}</b-form-select-option
            >
          </b-form-select>
        </div>
        <div v-if="provincia">
          <p class="pt-1 mb-0 text-secondary text-left">Comune:</p>
          <b-form-select v-model="comune" class="mt-2 mb-4" @change="fetchData">
            <b-form-select-option :value="null"
              >Scegli comune</b-form-select-option
            >
            <b-form-select-option
              v-for="(element, ind) in comuni"
              :key="ind"
              :value="element.comune"
              >{{ element.comune }}</b-form-select-option
            >
          </b-form-select>
        </div>
        <div>
          <p class="pt-1 mb-0 text-secondary text-left">
            Seleziona {{ professionista.tipo }}:
          </p>
          <p
            class="text-justify mb-0 text-danger"
            v-if="this.comune && lista.length < 1"
          >
            Ci spiace, al momento non ci sono operatori disponibili al
            teleconsulto per questo comune. Invita il tuo medico e la tua
            farmacia ad aderire!
          </p>
          <b-form-select v-model="selected" class="my-4" @change="setName">
            <b-form-select-option :value="null"
              >Scegli {{ professionista.tipo }}</b-form-select-option
            >
            <b-form-select-option
              v-for="(element, ind) in lista"
              :key="ind"
              :value="element"
              >{{ element.fullname }}</b-form-select-option
            >
          </b-form-select>
        </div>

        <!-- </div> -->
        <br />

        <b-button
          :disabled="professionista.rif == null"
          variant="primary"
          @click="seleziona"
          class="mr-2"
          >Seleziona</b-button
        >
      </div>
    </b-overlay>
  </div>
</template>
<script>
export default {
  name: "step-uno",
  props: ["actual"],
  data() {
    return {
      lista: null,
      ruoli: [{ text: "Seleziona categoria", value: null }],
      professionista: { tipo: null, rif: null, nome: null },
      loading: true,
      selected: null,
      contatti: null,
      regioni: null,
      province: null,
      comuni: null,
      regione: null,
      provincia: null,
      comune: null,
    };
  },
  methods: {
    seleziona() {
      this.$emit("add-professionista", this.professionista);
    },
    setName(el) {
      if (this.professionista.rif == null) {
        this.professionista.rif = el.hashid;
        this.professionista.nome = el.fullname;
      } else {
        this.professionista.rif = null;
      }
    },
    getRuoli() {
      var url = process.env.VUE_APP_VERSION + "ruolo/all";
      this.$axios
        .get(url)
        .then((res) => {
          res.data.data.map((val) => {
            this.ruoli.push(val);
          });
          this.loading = false;
        })
        .catch((err) => {
          if (err.response.status === 401) {
            this.$router.go();
          }
        });
    },
    handleRegioni() {
      this.getProvincie();
      this.getComuni();
      this.fetchData();
      this.provincia = null;
      this.comune = null;
    },
    handleProvince() {
      this.getComuni();
      this.fetchData();
      this.comune = null;
    },
    getRegioni() {
      var url = process.env.VUE_APP_VERSION + "regioni";
      this.$axios
        .get(url)
        .then((res) => {
          this.regioni = res.data.data;
        })
        .catch((err) => {
          if (err.response.status === 401) {
            this.$router.go();
          }
        });
    },
    getProvincie() {
      var url = process.env.VUE_APP_VERSION + "province/" + this.regione;
      this.$axios
        .get(url)
        .then((res) => {
          this.province = res.data.data;
        })
        .catch((err) => {
          if (err.response.status === 401) {
            this.$router.go();
          }
        });
    },
    getComuni() {
      this.fetchData();
      var url = process.env.VUE_APP_VERSION + "comuni/regioni/" + this.regione;
      if (this.provincia) {
        url = process.env.VUE_APP_VERSION + "comuni/province/" + this.provincia;
      }
      this.$axios
        .get(url)
        .then((res) => {
          this.comuni = res.data.data;
        })
        .catch((err) => {
          if (err.response.status === 401) {
            this.$router.go();
          }
        });
    },
    getContatti() {
      var url = process.env.VUE_APP_VERSION + "users/contatti";
      this.$axios
        .get(url)
        .then((res) => {
          // console.log("contatti", res.data.data);
          this.contatti = res.data.data;
        })
        .catch((err) => {
          if (err.response.status === 401) {
            this.$router.go();
          }
        });
    },
    fetchData() {
      if (this.professionista.tipo) {
        this.loading = true;
        var url = process.env.VUE_APP_VERSION + this.professionista.tipo;
        if (this.regione) {
          // console.log("fetching prof per regione");
          url =
            process.env.VUE_APP_VERSION +
            "professionisti/" +
            this.professionista.tipo +
            "/regioni/" +
            this.regione;

          if (this.provincia) {
            // console.log("fetching prof per provincia");
            url =
              process.env.VUE_APP_VERSION +
              "professionisti/" +
              this.professionista.tipo +
              "/province/" +
              this.provincia;

            if (this.comune) {
              // console.log("fetching prof per comune");
              url =
                process.env.VUE_APP_VERSION +
                "professionisti/" +
                this.professionista.tipo +
                "/comuni/" +
                this.comune;
            }
          }
        }
        // var url = process.env.VUE_APP_VERSION + this.professionista.tipo;
        this.$axios
          .get(url, {
            // params: { esame: this.$route.params.parametro },
          })
          .then((res) => {
            this.lista = res.data.data;
            this.loading = false;
          })
          .catch((err) => {
            if (err.response.status === 401) {
              this.$router.go();
            }
          });
      }
    },
  },
  created() {
    this.getRuoli();
    this.getContatti();
    this.getRegioni();
  },
};
</script>
<style scoped>
.hide__opt {
  display: none;
}
</style>
